/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ shown: NonNullable<unknown>, total: NonNullable<unknown>, suffix: NonNullable<unknown> }} Explorer_Search_Results_CountInputs */

const en_explorer_search_results_count = /** @type {(inputs: Explorer_Search_Results_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Showing ${i?.shown} of ${i?.total} result${i?.suffix}`)
};

const fr_explorer_search_results_count = /** @type {(inputs: Explorer_Search_Results_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Showing ${i?.shown} of ${i?.total} result${i?.suffix}`)
};

const de_explorer_search_results_count = /** @type {(inputs: Explorer_Search_Results_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Showing ${i?.shown} of ${i?.total} result${i?.suffix}`)
};

const it_explorer_search_results_count = /** @type {(inputs: Explorer_Search_Results_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Showing ${i?.shown} of ${i?.total} result${i?.suffix}`)
};

const ru_explorer_search_results_count = /** @type {(inputs: Explorer_Search_Results_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Showing ${i?.shown} of ${i?.total} result${i?.suffix}`)
};

const es_explorer_search_results_count = /** @type {(inputs: Explorer_Search_Results_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Showing ${i?.shown} of ${i?.total} result${i?.suffix}`)
};

const zh_cn2_explorer_search_results_count = /** @type {(inputs: Explorer_Search_Results_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Showing ${i?.shown} of ${i?.total} result${i?.suffix}`)
};

const ja_explorer_search_results_count = /** @type {(inputs: Explorer_Search_Results_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Showing ${i?.shown} of ${i?.total} result${i?.suffix}`)
};

const hi_explorer_search_results_count = /** @type {(inputs: Explorer_Search_Results_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Showing ${i?.shown} of ${i?.total} result${i?.suffix}`)
};

const pt_pt2_explorer_search_results_count = /** @type {(inputs: Explorer_Search_Results_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Showing ${i?.shown} of ${i?.total} result${i?.suffix}`)
};

/**
* | output |
* | --- |
* | "Showing {shown} of {total} result{suffix}" |
*
* @param {Explorer_Search_Results_CountInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_search_results_count = /** @type {((inputs: Explorer_Search_Results_CountInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Search_Results_CountInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_search_results_count(inputs)
	if (locale === "de") return de_explorer_search_results_count(inputs)
	if (locale === "it") return it_explorer_search_results_count(inputs)
	if (locale === "ru") return ru_explorer_search_results_count(inputs)
	if (locale === "es") return es_explorer_search_results_count(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_search_results_count(inputs)
	if (locale === "ja") return ja_explorer_search_results_count(inputs)
	if (locale === "hi") return hi_explorer_search_results_count(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_search_results_count(inputs)
	return en_explorer_search_results_count(inputs)
});